import { createAsyncThunk } from '@reduxjs/toolkit';

import { IDisplayDepartmentDTO } from 'src/api/dtos';
import DepartmentRepository from 'src/api/repositories/ess/v1/department.repository';

export const fetchDepartments = createAsyncThunk<IDisplayDepartmentDTO[], void>(
  'department',
  async (_, { rejectWithValue }) => {
    try {
      const repository = new DepartmentRepository();
      return await repository.get();
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
